import {
  StipulationMocks,
  SummaryLevelZeroMocks,
  SummaryMilesAvailableMocks
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  DisplayProperties,
  Tracker as TrackerUI
} from '@com-delta-omnichannel/aura';
import {
  CardCarouselMultiple13Mocks,
  EarnsSummaryMocks,
  MicroMomentsLyftMocks,
  NewMemberQuickLinksMocks,
  OnboardingMocks,
  SkyClubTrackerMultipleCardsMocks,
  SnapshotEntryItemMocks,
  StandardBenefitsMocks,
  Upgrades03Mocks
} from '../../../features';
import { SkyclubTrackerMultipleCardMocks } from '../../../features/skyclub/mocks/skyclub.mocks';
import { EarnsMocks } from '../../earns/mocks';
import { OverviewPage, Tracker } from '../models/overview-page.interfaces';

export const TrackerUIMocks: TrackerUI = {
  header: { title: '2025 STATUS PROGRESS', subtitle: 'Diamond Medallion' },
  earnometer: {
    limits: { min: '$0', max: '$18k' },
    value: '$15,300',
    currency: 'MQDs',
    tier: 'diamond',
    status: { current: '85', pending: '10' }
  },
  journey: {
    pending: '$1,800 MQDs Pending',
    info: 'Pending Earnings are calculated using your planned travel. Once you’ve taken your trip, the earnings will be posted.',
    reached: '',
    qualifier: ['$2,700 MQDs to Diamond Medallion'],
    more: '',
    ariaLabels: {
      pending: 'Pending info'
    }
  },
  legends: { tier: 'diamond', types: ['earned', 'pending'] },
  timeFrame: 'You have from Jan 1 to Dec 31 to earn status.',
  action: { type: 'text', link: { label: 'How to Reach Status?', url: '' } },
  ariaLabel: ''
};

export const TrackerUIDefaultMocks: TrackerUI = {
  header: {
    title: '2025 STATUS PROGRESS',
    subtitle: 'Platinum Medallion'
  },
  earnometer: {
    limits: { min: '$0', max: '$18k' },
    value: '$15,300',
    currency: 'MQDs',
    tier: 'platinum',
    status: { current: '85', pending: '10' }
  },
  journey: {
    pending: '$1,800 MQDs Pending',
    info: 'Pending Earnings are calculated using your planned travel. Once you’ve taken your trip, the earnings will be posted.',
    reached: '',
    qualifier: ['$2,700 MQDs to Platinum Medallion'],
    more: '',
    ariaLabels: {
      pending: 'Pending info'
    }
  },
  legends: { tier: 'platinum', types: ['earned', 'pending'] },
  timeFrame: 'You have from Jan 1 to Dec 31 to earn status.',
  action: { type: 'text', link: { label: 'How to Reach Status?', url: '' } },
  ariaLabel: ''
};

export const TrackerErrorUIMocks: TrackerUI = {
  header: { title: '2025 STATUS PROGRESS', subtitle: 'Platinum Medallion' },
  earnometer: {
    limits: { min: '$0', max: '$18k' },
    value: '$15,300',
    currency: 'MQDs',
    tier: 'platinum',
    status: { current: '85', pending: '10' }
  },
  journey: {
    pending: '$1,800 MQDs Pending',
    info: 'Pending Earnings are calculated using your planned travel. Once you’ve taken your trip, the earnings will be posted.',
    reached: 'Diamond Medallion Reached',
    qualifier: [],
    more: '',
    ariaLabels: {
      pending: 'Pending info'
    }
  },
  legends: { tier: 'platinum', types: ['earned', 'pending'] },
  timeFrame: 'You have from Jan 1 to Dec 31 to earn status.',
  action: { type: 'text', link: { label: 'How to Reach Status?', url: '' } },
  ariaLabel: ''
};

export const TrackerMocks: Tracker = {
  ...TrackerUIMocks,
  loaded: true,
  disabled: false,
  educationalTitle: 'Earning Medallion Status'
};

export const TrackerDefaultMocks: Tracker = {
  ...TrackerUIDefaultMocks,
  loaded: true,
  disabled: false,
  educationalTitle: 'Earning Medallion Status'
};

export const TrackerErrorMock: Tracker = {
  ...TrackerErrorUIMocks,
  loaded: true,
  disabled: false,
  educationalTitle: 'Earning Medallion Status'
};

export const TrackerMock: DisplayProperties = {
  disabled: true,
  error: undefined,
  loaded: true
};

export const OverviewPageMocks: OverviewPage = {
  onboarding: OnboardingMocks,
  microMoments: MicroMomentsLyftMocks,
  header: 'SkyMiles Overview',
  tracker: TrackerMocks,
  summary: SummaryMilesAvailableMocks,
  status: SummaryLevelZeroMocks,
  cards: CardCarouselMultiple13Mocks,
  quickLinks: NewMemberQuickLinksMocks,
  benefits: StandardBenefitsMocks,
  // benefits: delta360BenefitsMocks,
  snapshot: SnapshotEntryItemMocks,
  upgrades: Upgrades03Mocks,
  earns: EarnsMocks,
  stipulation: StipulationMocks,
  earnsSummary: EarnsSummaryMocks,
  skyclubTracker: SkyclubTrackerMultipleCardMocks,
  amexSkyClubTracker: SkyClubTrackerMultipleCardsMocks
};
